import Api from "../index";
import { endPoints, requestType } from "../../constants/variables";

export const LoginUser=params=>{
    return Api(endPoints.login,params,requestType.POST);
}

